import { useEffect } from "react"

const LOGO_URL = "https://static.lumi.new/37/3793f44e6693fd676f8244a63bcb3113.webp"
const BANNER_URL = "https://static.lumi.new/58/58cde9914b11f7da21bfa82cb6f6e6ab.webp"
const SITE_TITLE = "Haven Integrative Health Consulting | Clinical Expertise. Elevated Wellness."
const SITE_DESC =
  "Haven Integrative Health Consulting \u2014 pharmacist-led integrative care across IV nutrient therapy, menopause, acne, and travel medicine. Personalized, evidence-based wellness."

function upsertLink(rel: string, href: string, extra?: Record<string, string>) {
  let el = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement("link")
    el.setAttribute("rel", rel)
    document.head.appendChild(el)
  }
  el.setAttribute("href", href)
  if (extra) {
    Object.entries(extra).forEach(([k, v]) => el!.setAttribute(k, v))
  }
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement("meta")
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute("content", content)
}

function BrandHead() {
  useEffect(() => {
    // Favicon (shown in Google search results / browser tab)
    upsertLink("icon", LOGO_URL, { type: "image/webp" })
    upsertLink("shortcut icon", LOGO_URL, { type: "image/webp" })
    upsertLink("apple-touch-icon", LOGO_URL)

    // Title & description
    if (document.title !== SITE_TITLE) document.title = SITE_TITLE
    upsertMeta("name", "description", SITE_DESC)

    // Open Graph (Facebook, LinkedIn, iMessage, etc.)
    upsertMeta("property", "og:title", SITE_TITLE)
    upsertMeta("property", "og:description", SITE_DESC)
    upsertMeta("property", "og:image", BANNER_URL)
    upsertMeta("property", "og:image:alt", "Haven Integrative Health Consulting")
    upsertMeta("property", "og:type", "website")
    upsertMeta("property", "og:site_name", "Haven Integrative Health Consulting")

    // Twitter / X
    upsertMeta("name", "twitter:card", "summary_large_image")
    upsertMeta("name", "twitter:title", SITE_TITLE)
    upsertMeta("name", "twitter:description", SITE_DESC)
    upsertMeta("name", "twitter:image", BANNER_URL)

    // Google search result thumbnail hint
    upsertMeta("name", "thumbnail", LOGO_URL)
    upsertMeta("property", "og:image", LOGO_URL)
  }, [])

  return null
}

export default BrandHead
